const riot = require('riot');
import './segment.tag';
import './target_site.tag';
riot.tag2('campaign', '<form if="{loaded}"> <div class="columns"> <div class="column"> <div class="field control"> <label for="name" class="label">Name</label> <input class="input" disabled="{campaign.isAutomated}" type="text" riot-value="{campaign.name}" id="name" ref="name"> </div> <div class="field"> <div class="control"> <label for="id" class="label">Customer</label> <div class="control"> <div class="select is-small"> <select name="new_customer" disabled="{campaign.isAutomated}" ref="new_customer" onchange="{setCustomer}"> <option>Select customer</option> <option each="{customers}" selected="{_id == campaign.customer_id}" riot-value="{_id}">{name}</option> </select> </div> </div> </div> </div> <div class="field columns"> <div class="control column"> <label for="active_{campaign._id}" class="label">Status</label> <input type="checkbox" name="active" id="active_{campaign._id}" ref="active" class="switch is-info" checked="{campaign.active}"><label for="active_{campaign._id}">Active</label> </div> <div class="control column"> <label for="utm_tags" class="label">UTM tags</label> <div class="select is-small"> <select name="utm_tags" ref="utm_tags"> <option selected="{!campaign.utm_tags}" value="">Disabled</option> <option selected="{campaign.utm_tags == \'utm\' || campaign.utm_tags == true}" value="utm">UTM</option> <option selected="{campaign.utm_tags == \'bex\'}" value="bex">BEX</option> </select> </div> </div> <div class="control column"> <label for="tcf_friendly_{campaign._id}" class="label">TCF Friendly </label> <input type="checkbox" name="tcf_friendly" id="tcf_friendly_{campaign._id}" ref="tcf_friendly" class="switch is-info" checked="{campaign.tcf_friendly}"><label for="tcf_friendly_{campaign._id}">safe to show</label> </div> </div> <div class="field" if="{!campaign.isAutomated}"> <div class="control"> <label for="append_qry" class="label">Append to URL</label> <textarea name="append_qry" id="append_qry" ref="append_qry" class="textarea" placeholder="e.g. url_parameter=##macro## all macros ##segment_name## ##segment_id## ##route_name## ##route_id## ##campaign_name## ##campaign_id## ##customer_id## ##item_name## ##item_sku## ##item_id## ##host## ##user## ">{campaign.append_qry.replace(/&/g,\'\\n\')}</textarea> </div> </div> <div class="field columns"> <div class="control column"> <label for="preview_{campaign._id}" class="label">Preview Campaign</label> <input type="checkbox" name="preview" id="preview_{campaign._id}" ref="preview" class="switch is-info" checked="{campaign.ce_dmp_preview}"><label for="preview_{campaign._id}">Preview</label> </div> <div class="control column"> <label for="block_ads_{campaign._id}" class="label">Block Ads</label> <input type="checkbox" name="block_ads" id="block_ads_{campaign._id}" ref="block_ads" class="switch is-info" checked="{campaign.block_ads}"><label for="block_ads_{campaign._id}">Block Ads</label> </div> <div class="control column"> <label for="block_events" class="label">Block Events</label> <div class="select is-small"> <select name="block_events" ref="block_events"> <option selected="{campaign.block_events == \'\'}" value="">disable</option> <option selected="{campaign.block_events == \'block\'}" value="block">enable</option> </select> </div><br> <small for="block_events">Skip route requests and impressions</small> </div> </div> </div> <div class="column"> <div class="field is-grouped"> <div class="control"> <label for="dt_start" class="label">Start Date</label> <input class="input" disabled="{campaign.isAutomated}" riot-value="{campaign.day_start}" id="dt_start" ref="dt_start" type="{\'date\'}"> </div> <div class="control"> <label for="dt_end" class="label">End Date</label> <input class="input" disabled="{campaign.isAutomated}" riot-value="{campaign.day_end}" id="dt_end" ref="dt_end" type="{\'date\'}"> </div> <div class="control"> <label class="label">Actions</label> <button class="button is-info" onclick="{saveCampaign}">Save changes</button> </div> </div> <div class="field is-grouped"> <div class="control"> <label for="ip_limits" class="label">Limit to IPs</label> </div> <div class="control"> <div class="select is-small"> <select name="ip_limit_mode" ref="ip_limit_mode"> <option value="">disabled</option> <option each="{ip_limit_modes}" riot-value="{_id}" selected="{_id == campaign.ip_limit_mode}">{label}</option> </select> </div> </div> </div> <div class="field"> <div class="control"> <textarea class="textarea" name="ip_limits" id="ip_limits" ref="ip_limits">{campaign.ip_limits}</textarea> </div> </div> <div class="field"> <div class="control"> <label for="ip_exclude" class="label">Exclude IPs from statistics</label> <textarea class="textarea" name="ip_exclude" id="ip_exclude" ref="ip_exclude">{campaign.ip_exclude}</textarea> </div> </div> </div> </div> <div class="columns"> <div class="column"> <h4 class="title is-6">Segments</h4> <div class="columns"> <div if="{!campaign.isAutomated}" class="field column is-grouped"> <div class="control"> <div class="select is-small"> <select name="new_segment" ref="new_segment"> <option value="">Select audience</option> <option each="{profiles_filtered}" riot-value="{_id}">{name}</option> </select> </div> </div> <div class="control"> <button class="button is-light is-small" onclick="{addSegment}">Add segment</button> </div> </div> <div class="field column is-grouped"> <div class="control"> <label for="match_mode" class="label">Segment matching</label> </div> <div class="control"> <div class="select is-small"> <select name="match_mode" ref="match_mode"> <option>Select mode</option> <option each="{match_modes}" selected="{_id == campaign.match_mode}" riot-value="{_id}">{label}</option> </select> </div> </div> </div> </div> <segment each="{segments_mapped}"></segment> </div> </div> <div class="columns"> <div class="column"> <h4 class="title is-6">Sites</h4> <div class="field is-grouped" if="{!campaign.isAutomated}"> <div class="control"> <div class="select is-small"> <select name="new_site" ref="new_site" onchange="{customActive}"> <option value="">Select target site</option> <option value="custom">Custom site</option> <option each="{sites_filtered}" riot-value="{_id}">{name}</option> </select> </div> </div> <div class="control"> <input class="input is-small" disabled type="text" id="custom_site" ref="custom_site" placeholder="Custom site URL"> </div> <div class="control"> <button class="button is-light is-small" onclick="{addSite}">Add site</button> </div> </div> <target_site each="{sites_mapped}"></target_site> </div> </div> </form>', '', '', function(opts) {


		const self = this;
		const conf = api.get('config');

		self.customers = [];
		self.campaign = {};
		self.profiles = [];
		self.sites = [];
		self.loaded = false

		self.profiles_filtered = [];
		self.sites_filtered = [];

		self.segments_mapped = [];
		self.sites_mapped = [];

		{
			self.match_modes = [{
				_id: 'best',
				label: 'best match'
			}, {
				_id: 'mix',
				label: 'any match'
			}, {
			  _id: 'multi',
			  label: 'mix matches'
			}];
			self.ip_limit_modes = [{
				_id: 'include',
				label: 'Limit to listed IPs'
			}, {
				_id: 'exclude',
				label: 'Disable for listed IPs'
			}];
		}

    api.on('update-audience',function(e) {
		  loadSegments()
    })

		function loadSegments() {

		  var customers = self.campaign.isAutomated ? self.campaign.customer_id : [self.campaign.customer_id]
			return api.service('audiences').find({ query: { customer_id: {$in:customers}, $select:['_id','name','filter','iab_filter','keyword'],$limit:1000 } })
				.then(profiles => {

					self.profiles = profiles.data;

					updateSegments();
					self.update();
				})
				.catch(err => api.emit('toast', { type:'danger', title:'Error setting up segments', content:err.message }));
		}
		function updateSegments() {

			self.campaign.segments = self.campaign.segments || [];

			let segments = {}, profiles = {};

			for(let profile of self.profiles)
				profiles[profile._id] = profile;

console.log('campaign udating segments',profiles,self.campaign.segments)

      self.campaign.segments = self.campaign.segments.filter(s => !!profiles[s.profile_id])
console.log('campaign filtered segments',self.campaign.segments)

			for(let segment of self.campaign.segments)
				segments[segment.profile_id] = segment;

			self.profiles_filtered = self.profiles.filter(a => !segments[a._id]);
			self.segments_mapped = self.profiles.filter(a => segments[a._id]).map(a => ({ profile: a,segment: segments[a._id] }));
		}
		function updateSites() {

			self.campaign.target_sites = self.campaign.target_sites || [];

      if (self.campaign.isAutomated) {
        self.sites_filtered = []
			} else {

				let all_sites = []

				let customer = self.customers.find(a => a._id == self.campaign.customer_id);
				self.customer = customer
				if(!customer) return api.emit('toast', { type: 'danger', title: 'Invalid customer ID' });
				all_sites = customer.target_sites || [];

				let sites = {}

				for(let site of self.campaign.target_sites) {
					if (site.site._id) sites[site.site._id] = site;
				}

				self.sites_filtered = all_sites.filter(a => !sites[a._id]);
			}

			self.sites = self.campaign.target_sites
			self.sites_mapped = self.campaign.target_sites.map(a => ({ site: a.site , target: a }))

		}

		this.customActive = function(e) {
			console.log('customActive',self.refs.new_site.value)
			self.refs.custom_site.disabled = self.refs.new_site.value !== 'custom';
		}.bind(this)

		this.addSite = function(e) {
			e.preventDefault();

			let id = self.refs.new_site.value, site = false;
			if(!id) return api.emit('toast', { type: 'danger', title: 'Select site first' });
			if(id=='custom') {
				id = self.refs.custom_site.value
				if(!id) return api.emit('toast', { type: 'danger', title: 'Enter custom site URL' });
				site = {
					_id: id,
					name: id,
					url: id
				}
			} else {
				site = self.sites.find(a => a._id == id);
			}

			if(!site) return api.emit('toast', { type: 'danger', title: 'Invalid site ID' });

			let target = {
				routes: [],
				aliases: [],
				parameter_mode: 'include',
				site: site
			}

			self.campaign.target_sites.push(target);
			self.sites_mapped.push({ site, target });
			self.sites_filtered = self.sites_filtered.filter(a => a._id !== id);

			self.update();
		}.bind(this)
		this.removeSite = function(e) {
			e.preventDefault();

			self.sites_filtered.push(e.item.site);
			self.sites_mapped = self.sites_mapped.filter(a => a.site._id !== e.item.site._id);
			self.campaign.target_sites = self.campaign.target_sites.filter(a => a.site._id !== e.item.site._id);

			self.update();
		}.bind(this)
		this.addSegment = function(e) {
			e.preventDefault();

			let id = self.refs.new_segment.value;
			if(!id) return api.emit('toast', { type: 'danger', title: 'Select segment first' });

			let profile = self.profiles.find(a => a._id == id);
			if(!profile) return api.emit('toast', { type: 'danger', title: 'Invalid segment ID' });

			let segment = {
				fixed_mode: 'disable',
				time_limit: {
					mode: 'disable',
					intervals: []
				},
				goal_limit: {
					mode: 'disable'
				},
				profile_id: id,
				name: profile.name,
				selected: []
			};

			self.campaign.segments.push(segment);
			self.segments_mapped.push({ profile, segment });
			self.profiles_filtered = self.profiles_filtered.filter(a => a._id !== id);

			self.update();
		}.bind(this)
		this.removeSegment = function(e) {
			e.preventDefault();

			self.profiles_filtered.push(e.item.profile);
			self.segments_mapped = self.segments_mapped.filter(a => a.segment.profile_id !== e.item.segment.profile_id);
			self.campaign.segments = self.campaign.segments.filter(a => a.profile_id !== e.item.segment.profile_id);

			self.update();
		}.bind(this)
		this.setDefaultSegment = function(e) {
			e.preventDefault();

			for(let segment of self.campaign.segments) {
				if(segment.isDefault)
					delete segment['isDefault'];
				else if(segment.profile_id === e.item.segment.profile_id) {
					segment['isDefault'] = true;
					segment['pinned'] = false
			  }
			}

			self.update();
		}.bind(this)
		this.setPinnedSegment = function(e) {
			e.preventDefault();

			for(let segment of self.campaign.segments) {
				if(segment.pinned)
					segment['pinned'] = false;
				else if(segment.profile_id === e.item.segment.profile_id) {
					segment['pinned'] = true;
					segment.pinned_posts = segment.pinned_posts || 1
			  }
			}

			self.update();
		}.bind(this)

		this.setCustomer = function(e) {
			e.preventDefault();

			self.campaign.customer_id = self.refs.new_customer.value;

			updateSites();
			loadSegments();
		}.bind(this)
		this.saveCampaign = function(e) {
			e.preventDefault();

			let changes = self.campaign.isAutomated
			? {

				active: self.refs.active.checked,
				ce_dmp_preview: self.refs.preview.checked,
				utm_tags: self.refs.utm_tags.value,
				match_mode: self.refs.match_mode.value,
				block_events: self.refs.block_events.checked,
				block_ads: self.refs.block_ads.checked,
				ip_limits: self.refs.ip_limits.value,
				ip_limit_mode: self.refs.ip_limit_mode.value,
				ip_exclude: self.refs.ip_exclude.value,

			}
			: {
				name: self.refs.name.value,
				active: self.refs.active.checked,
				ce_dmp_preview: self.refs.preview.checked,
				utm_tags: self.refs.utm_tags.value,
				tcf_friendly: self.refs.tcf_friendly.checked,
				append_qry: self.refs.append_qry.value.replace(/\n/g,'&'),
				block_events: self.refs.block_events.checked,
				block_ads: self.refs.block_ads.checked,
				match_mode: self.refs.match_mode.value,
				ip_limits: self.refs.ip_limits.value,
				ip_limit_mode: self.refs.ip_limit_mode.value,
				ip_exclude: self.refs.ip_exclude.value,
				dtstart: new Date(self.refs.dt_start.value+'T00:00:00'),
				dtend: new Date(self.refs.dt_end.value+'T00:00:00')
			}

			let promise_land = [];

			for(let site of self.campaign.target_sites) {
				for(let route of site.routes) {
					if(!route.widget)
						continue;

					if(route.widget_id) {
						promise_land.push(api.service('widgets').patch(route.widget_id, route.widget));
					} else {
						promise_land.push(api.service('widgets').create(route.widget)
							.then(data => route.widget_id = data._id));
					}

					delete route['widget'];
				}
			}

			Promise.all(promise_land)
				.then(() => {
					api.service('campaigns').patch(self.campaign._id, Object.assign(self.campaign, changes))
						.then(data => {

							self.campaign = data;
							updateSites();
							updateSegments();
							self.update();

							fetch(conf.tracker + '/bex/reset/' + self.campaign._id)
								.then(() => {
									api.emit('toast', { type: 'info', title: 'Campaign saved' });
									self.update();
								})
								.catch(err => {
									api.emit('toast', { type: 'danger', title: 'Error resetting campaign', content: err.message });
									self.update();
								});
						})
						.catch(err => {
							api.emit('toast', { type: 'danger', title: 'Error saving campaign', content: err.message });
							self.update();
						});
				})
				.catch(err => {
					api.emit('toast', { type: 'danger', title: 'Error deleting widgets', content: err.message });
					self.update();
				});
		}.bind(this)

    api.on('update-customer', (e) => {
      self.customers = api.get('customers')
      self.update()
    })

		self.on('mount', () => {
		  const campaign_id = opts.campaign_id || riotRoute.args[0] || false

			if(!campaign_id)
				return api.emit('toast', { type:'danger', title:'No campaign ID specified!' });

			return core.customerAPI.GetOrSet()
			.catch(err => api.emit('toast', { type:'danger', title:'Error fetching customers', content:err.message }))
			.then(customers => {
				self.customers = customers;

	      return api.service('campaigns').get(campaign_id)
			})
			.catch(err => api.emit('toast', { type:'danger', title:'Error fetching campaign', content:err.message }))
			.then(campaign => {
			  if (campaign.dtstart) {
			    var d = new Date(campaign.dtstart)
				  campaign.day_start = [d.getFullYear(),('0'+(1+d.getMonth())).slice(-2),('0'+d.getDate()).slice(-2)].join('-')
				}
			  if (campaign.dtend) {
			    var d = new Date(campaign.dtend)
				  campaign.day_end = [d.getFullYear(),('0'+(1+d.getMonth())).slice(-2),('0'+d.getDate()).slice(-2)].join('-')
				}
				self.campaign = campaign;
				if ( campaign.isAutomated && !Array.isArray(campaign.customer_id) ) campaign.customer_id = [campaign.customer_id]
				console.log('have campaign',campaign)
				updateSites();
				self.loaded = true
				return core.templatesAPI.GetOrSet()
		  })
		  .then(templates => {
				self.templates = templates

				return loadSegments();
			})
		});
});
